export const juniorSubjects = [
  "English", "Mathematics", "Social Science", "Basic Science", 
  "Agriculture", "Religious Education", "French", "Technology"
];

export const seniorSubjects = [
  "English", "Mathematics", "Physics", "Biology", "Chemistry", 
  "Accounting", "Economics", "Development Studies", 
  "Geography", "History", "Agriculture", "ICT", "French"
];

export const generateTasks = (subject, year) => {
  const tasks = [];
  
  // LINKED TO SCHEME OF WORK: 40% Continuous Assessment (CA)
  // Computer Studies Year 13 Assessment Structure
  
  const juniorTypes = [
    { title: "Diagnostic", max: 50, weight: 10 },
    { title: "Project", max: 50, weight: 15 },
    { title: "Topic Test", max: 50, weight: 15 }
  ];

  // Computer Studies Year 13 Assessments (Linked to Scheme of Work & Blueprints)
  const computerStudiesYear13 = [
    { 
      title: "Unit 1.1: Assessment Blueprint", 
      max: 15, 
      weight: 2,
      linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.1",
      description: "Future ICT Trends formative assessment (MCQ & Short Answer)",
      blueprintId: "unit11_test",
      dueDate: "Term 1 - Week 2"
    },
    { 
      title: "Unit 1.1: ICT Exercises", 
      max: 35, 
      weight: 4,
      linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.1",
      description: "ICT exercises with Vanuatu context (Fill in blanks, Short answer, True/False, Discussion)",
      blueprintId: "unit11_exercises",
      dueDate: "Term 1 - Week 2"
    },
    { 
      title: "Unit 1.2: IS Management Test", 
      max: 60, 
      weight: 6,
      linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.2",
      description: "Workflows, IS applications, development and management in Vanuatu context",
      blueprintId: "unit12_test",
      dueDate: "Term 1 - Week 4"
    },
    { 
      title: "Unit 1.2: ICT Exercises", 
      max: 50, 
      weight: 5,
      linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.2",
      description: "Practical exercises on IS concepts with local government and tourism scenarios",
      blueprintId: "unit12_exercises",
      dueDate: "Term 1 - Week 4"
    },
    { 
      title: "Unit 1.2: ICT Assignment", 
      max: 60, 
      weight: 6,
      linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.2",
      description: "Comprehensive assignment on IS management with Vanuatu Adventures case study",
      blueprintId: "unit12_assignment",
      dueDate: "Term 1 - Week 5"
    },
    { 
      title: "Unit 3.1: Data Representation Test", 
      max: 50, 
      weight: 5,
      linkedToScheme: "Strand 3: Programming - Unit 3.1",
      description: "Test on Unicode, number conversions, binary arithmetic, and logic gates",
      blueprintId: "unit31_test",
      dueDate: "Term 2 - Week 8"
    },
    { 
      title: "Unit 3.1: Assignment 1 - Digital Representation", 
      max: 30, 
      weight: 3,
      linkedToScheme: "Strand 3: Programming - Unit 3.1",
      description: "Research and conversion exercises on character encoding and number systems",
      blueprintId: "unit31_a1",
      dueDate: "Term 2 - Week 3"
    },
    { 
      title: "Unit 3.1: Assignment 2 - Binary Arithmetic", 
      max: 35, 
      weight: 3,
      linkedToScheme: "Strand 3: Programming - Unit 3.1",
      description: "Problem-solving exercises on binary addition, subtraction, multiplication, and division",
      blueprintId: "unit31_a2",
      dueDate: "Term 2 - Week 5"
    },
    { 
      title: "Unit 3.1: Assignment 3 - Logic Gates", 
      max: 25, 
      weight: 2,
      linkedToScheme: "Strand 3: Programming - Unit 3.1",
      description: "Truth table construction and logic circuit interpretation",
      blueprintId: "unit31_a3",
      dueDate: "Term 2 - Week 7"
    },
    { 
      title: "Unit 3.1: Assignment 4 - Circuit Design", 
      max: 20, 
      weight: 2,
      linkedToScheme: "Strand 3: Programming - Unit 3.1",
      description: "Application-based logic gate and circuit design",
      blueprintId: "unit31_a4",
      dueDate: "Term 2 - Week 8"
    },
    { 
      title: "IA Draft 1", 
      max: 100, 
      weight: 10,
      linkedToScheme: "Strand 1: Personal Computer Systems",
      description: "Internal Assessment Draft 1 - Digital Media & ICT Trends",
      dueDate: "Term 1"
    },
    { 
      title: "Moodle Activities", 
      max: 50, 
      weight: 5,
      linkedToScheme: "Multiple Strands",
      description: "Online exercises and activities",
      dueDate: "Term 1"
    },
    { 
      title: "Termly Test - Strand 1", 
      max: 100, 
      weight: 10,
      linkedToScheme: "Strand 1: Personal Computer Systems",
      description: "End of Term 1 assessment",
      dueDate: "Term 1"
    },
    { 
      title: "IA Draft 2", 
      max: 100, 
      weight: 10,
      linkedToScheme: "Strand 3: Programming",
      description: "Internal Assessment Draft 2 - Programming",
      dueDate: "Term 2"
    },
    { 
      title: "Website Development Project", 
      max: 100, 
      weight: 5,
      linkedToScheme: "Strand 2: Website Development",
      description: "Database-driven website project",
      dueDate: "Term 2"
    }
  ];

  const seniorTypes = [
    { title: "Diagnostic", max: 50, weight: 5 },
    { title: "Project", max: 50, weight: 10 },
    { title: "Practical", max: 50, weight: 10 },
    { title: "Topic Test", max: 50, weight: 15 }
  ];

  // Check if this is Computer Studies Year 13
  if (year === 13 && subject === "Computer Studies") {
    computerStudiesYear13.forEach((type, i) => {
      tasks.push({
        id: type.blueprintId || `Y13-CS-CA${i+1}`, // Use blueprintId as ID if available
        title: type.title, 
        type: "Continuous Assessment (40%)",
        weighting: type.weight, 
        maxMarks: type.max, 
        dueDate: type.dueDate || `Term ${i <= 2 ? 1 : 2}`,
        status: i === 0 ? "Completed" : "Planned",
        linkedToScheme: type.linkedToScheme,
        description: type.description,
        blueprintId: type.blueprintId // Link to blueprint if exists
      });
    });
  } else {
    // Use existing logic for other subjects
    const selectedTypes = year >= 11 ? seniorTypes : juniorTypes;

    selectedTypes.forEach((type, i) => {
      tasks.push({
        id: `${year}-${subject.replace(/\s+/g, '')}-IA${i+1}`,
        title: `IA ${i+1}: ${type.title}`, 
        type: "Internal Assessment",
        weighting: type.weight, 
        maxMarks: type.max, 
        dueDate: `Week ${i * 3 + 4}`,
        status: i === 0 ? "Completed" : "Planned"
      });
    });
  }

  return tasks;
};

// Import class-based assessments
import { getClassAssessments, classAssessmentStructure } from './classAssessments';

export const getAssessmentsForClass = (className) => {
  // Try to get from class-based structure first
  const classData = getClassAssessments(className);
  
  if (classData && classData.assessments) {
    return classData.assessments;
  }
  
  // Fallback to old system
  const yearMatch = className.match(/Year (\d+)/);
  if (!yearMatch) return [];
  
  const year = parseInt(yearMatch[1]);
  const subjectMatch = className.match(/Year \d+\s+(.+)/);
  const subject = subjectMatch ? subjectMatch[1] : "General";
  
  return generateTasks(subject, year);
};
